import { Component, OnDestroy } from '@angular/core';
import { RoomExaminationService } from '../room-examination.service';
import { ErrorListService } from '../../../../../reusable-components/error-list/error-list.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';

import { MatSelect } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { RoomClosedReason, roomClosedReasons } from '../../../../../lead.model';

@Component({
  selector: 'app-room-not-visited',
  imports: [
    MatCheckbox,
    FormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    TranslatePipe,
    MatLabel,
    MatFormField,
  ],
  templateUrl: './room-not-visited.component.html',
  styleUrl: './room-not-visited.component.scss',
})
export class RoomNotVisitedComponent implements OnDestroy {
  private readonly errorListService: ErrorListService;
  abortionReasons = roomClosedReasons;
  abortionReason: RoomClosedReason | '';
  error = 'components.room-not-visited.mat-select-error';

  constructor(public roomExaminationService: RoomExaminationService) {
    this.abortionReason =
      this.roomExaminationService.getRoomIsClosedReason() || '';
    this.errorListService =
      roomExaminationService.errorListServiceRoomNotVisited;

    this.updateErrors();
  }

  setRoomIsClosed(roomIsClosed: boolean) {
    this.roomExaminationService.setRoomIsClosed(roomIsClosed);
    if (roomIsClosed) {
      this.abortionReason = '';
    }
    this.updateErrors();
  }

  setAbortionReason(abortionReason: RoomClosedReason | ''): void {
    this.roomExaminationService.setRoomIsClosedReason(
      abortionReason !== '' ? abortionReason : undefined,
    );
    this.updateErrors();
  }

  updateErrors() {
    if (
      this.roomExaminationService.getRoomIsClosed() &&
      this.roomExaminationService.getRoomIsClosedReason() === undefined
    ) {
      this.errorListService.addError(this.error);
    } else {
      this.errorListService.removeError(this.error);
    }
  }

  ngOnDestroy(): void {
    this.errorListService.removeAllErrors();
  }
}
